import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

const NotFoundPage = () => {
  return (
    <>
      <Helmet>
        <title>404 - Sayfa Bulunamadı | Yağmur Demiröz</title>
      </Helmet>
      <div className="min-h-screen bg-background flex items-center justify-center px-4">
        <div className="max-w-lg w-full text-center">
          <h1 className="text-9xl font-bold text-primary">404</h1>
          <div className="absolute rotate-12 transform">
            <div className="absolute inset-0 h-1.5 w-1/2 bg-secondary rounded-lg"></div>
          </div>
          <div className="text-secondary text-xl md:text-2xl font-medium mb-8 mt-8">
            Aradığınız sayfa bulunamadı
          </div>
          <p className="text-gray-600 mb-8">
            Üzgünüz, aradığınız sayfaya ulaşılamıyor. Sayfa kaldırılmış, adı değiştirilmiş veya geçici olarak kullanım dışı olabilir.
          </p>
          <Link
            to="/"
            className="bg-primary text-secondary hover:bg-secondary hover:text-primary transition-all duration-300 px-6 py-3 rounded-lg font-medium inline-block"
          >
            Ana Sayfaya Dön
          </Link>
        </div>
      </div>
    </>
  );
};

export default NotFoundPage;
